import { isSuperAdminRole, isTenantAdminRole } from '@/shared/libs/admin-routes'
import { useAuthStore } from '@/shared/store/auth-store'

/**
 * Whether the signed-in user may add admins to `tenantId`.
 *
 * Mirrors the IAM rule: a super admin may add admins to any tenant, a tenant admin only when
 * they are that tenant's owner (head admin). Other admins get 403 from the API, so this only
 * decides whether to offer the action — it is not the security boundary.
 */
export function useCanManageTenantAdmins(tenantId: string): boolean {
  const user = useAuthStore((state) => state.user)
  if (!user) return false
  if (isSuperAdminRole(user.role)) return true
  return isTenantAdminRole(user.role) && user.isTenantOwner === true && user.tenantId === tenantId
}
